import { Controller } from 'react-hook-form';
import { ClickOutsideDetector, IconLoader, InputText, Select } from '@ui/src';
import { LinkedClientsFormTypes } from './types';

import cn from './styles.module.css';

let timeout: NodeJS.Timeout;

const LinkedClientsForm = ({
  control,
  availablePspPartners,
  selectedPartner,
  errors,
  customerName,
  setExternalOrganizationsListVisible,
  externalOrganizationSearch,
  setExternalOrganizationSearch,
  getPspIntegrationOrganizationsAction,
  pspPartnerId,
  pspIntegrationOrganizationsList,
  externalOrganizationsListVisible,
  organizationsIsLoading,
  organizationsIsFetching,
  type,
}: LinkedClientsFormTypes) => (
  <>
    <div className={cn.pspIntegrationSelect}>
      <Controller
        control={control}
        defaultValue=""
        name="pspPartnerId"
        render={({ field: { name, value, onChange } }) => (
          <Select
            name={name}
            list={availablePspPartners}
            value={selectedPartner || value}
            title="Bank"
            placeholder="Select Bank"
            onChange={onChange}
            error={errors?.pspPartnerId?.message}
            disabled={Boolean(selectedPartner)}
          />
        )}
      />
    </div>
    <div className={cn.pspIntegrationSelect}>
      <Controller
        control={control}
        defaultValue=""
        name="organizationId"
        render={({ field: { name } }) => (
          <InputText
            name={name}
            value={customerName}
            title="Customer"
            placeholder="Enter name..."
            error={errors?.organizationId?.message}
            disabled
          />
        )}
      />
    </div>
    <div className={cn.pspIntegrationSelect}>
      <Controller
        control={control}
        defaultValue=""
        name="externalId"
        render={({ field: { onChange } }) => (
          <ClickOutsideDetector
            setOptionsListVisible={setExternalOrganizationsListVisible}
          >
            <div className={cn.searchExternalOrganizationWrapper}>
              <InputText
                name="searchName"
                value={externalOrganizationSearch}
                title="External Customer"
                placeholder="Enter name..."
                onChange={(e) => {
                  clearTimeout(timeout);

                  setExternalOrganizationSearch(e.target.value);

                  if (e.target.value) {
                    timeout = setTimeout(() => {
                      getPspIntegrationOrganizationsAction({
                        name: e.target.value,
                      });
                    }, 700);
                  }
                }}
                disabled={!pspPartnerId}
                onFocus={() => {
                  if (pspIntegrationOrganizationsList?.length) {
                    setExternalOrganizationsListVisible(true);
                  }
                }}
                error={errors?.externalId?.message}
              />
              {externalOrganizationsListVisible && (
                <div className={cn.organizationList}>
                  {(organizationsIsLoading || organizationsIsFetching) && (
                    <div className={cn.organizationListLoader}>
                      <IconLoader />
                    </div>
                  )}
                  {!organizationsIsLoading &&
                    !organizationsIsFetching &&
                    pspIntegrationOrganizationsList &&
                    pspIntegrationOrganizationsList?.length > 0 &&
                    pspIntegrationOrganizationsList?.map((item) => (
                      <button
                        type="button"
                        className={cn.organizationButton}
                        key={item.externalId}
                        onClick={() => {
                          setExternalOrganizationsListVisible(false);
                          onChange(item.externalId);
                          setExternalOrganizationSearch(item.name);
                        }}
                        disabled={Boolean(item.organizationType !== type)}
                      >
                        <div className={cn.organizationButtonLeft}>
                          {item.name}
                        </div>
                        <div className={cn.organizationButtonRight}>
                          {item.organizationType
                            .split('_')
                            ?.map(
                              (organizationType) =>
                                `${organizationType.charAt(0)}${organizationType.slice(1).toLowerCase()}`,
                            )
                            .join(' ')}
                        </div>
                        <div className={cn.externalOrganizationId}>
                          {item.externalId}
                        </div>
                        {item.organizationType !== type && (
                          <div className={cn.wrongType}>
                            The external customer type does not match the
                            current customer type
                          </div>
                        )}
                      </button>
                    ))}
                  {!pspIntegrationOrganizationsList?.length &&
                    !organizationsIsLoading &&
                    !organizationsIsFetching && (
                      <div className={cn.organizationButton}>
                        No customer yet
                      </div>
                    )}
                </div>
              )}
            </div>
          </ClickOutsideDetector>
        )}
      />
    </div>
  </>
);

export default LinkedClientsForm;
